import React from 'react';
import { IconProps } from './types';

export const TrendIcon: React.FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    width="18"
    height="18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="1.5"
      y="1.5"
      width="17"
      height="17"
      rx="3.5"
      stroke="currentColor"
      strokeOpacity="0.4"
      strokeWidth="1.2"
    />
    <path
      d="M4.5 13.5L8 9.5L11 12L15.5 6.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
